import { render, staticRenderFns } from "./app-messages.vue?vue&type=template&id=4aa2a41f&scoped=true&"
import script from "./app-messages.vue?vue&type=script&lang=js&"
export * from "./app-messages.vue?vue&type=script&lang=js&"
import style0 from "./app-messages.vue?vue&type=style&index=0&id=4aa2a41f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2a41f",
  null
  
)

export default component.exports